import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[calc(100vh-9rem)] xl:min-h-[calc(100vh-10.75rem)] overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          src="https://ik.imagekit.io/paik34n1e/Kapil_%20Homepage.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover hero-bg-video"
        />
      </div>

      {/* Dark Overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(90deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.45) 20%, rgba(0,0,0,0.15) 80%, rgba(0,0,0,0) 100%)",
        }}
      ></div>

      {/* Content */}
      <div className="relative z-10 flex min-h-[calc(100vh-9rem)] xl:min-h-[calc(100vh-10.75rem)] items-center pt-12 pb-36 md:pt-20 md:pb-40">
        <div className="max-w-7xl mx-auto w-full px-6 lg:px-12">
          <div className="max-w-4xl">

            <h1
              className="text-white font-semibold text-4xl md:text-6xl"
              style={{ lineHeight: "1.3" }}
            >
              Powering Global Growth
              <br />
              Through Technology Talent
            </h1>

            <div className="w-32 h-[3px] bg-white mt-8 mb-8"></div>

            <p
              className="text-lg md:text-xl leading-relaxed
              max-w-2xl mb-10" style={{ color: "white" }}
            >
              Access a global network of highly skilled technology
              professionals and build high-performing teams with speed,
              quality, and confidence.
            </p>

            <div className="flex flex-wrap gap-5">
              <Link
                to="/"
                className="bg-[#005FA3] hover:bg-[#004b82]
                text-white font-semibold px-10 py-4
                transition-all duration-300"
              >
                Apply For Job
              </Link>

              <Link
                to="/contact"
                className="bg-[#ff0000] hover:bg-[#b61f1f]
                text-white font-semibold px-10 py-4
                transition-all duration-300"
              >
                Find Talent
              </Link>
            </div>

          </div>
        </div>

        {/* Bottom Tech Bar */}
        <div className="absolute bottom-6 left-0 w-full md:bottom-8">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="flex flex-wrap items-center justify-around md:justify-between gap-5 md:gap-12 border-t border-white/20 pt-6">
              <span className="text-white font-bold text-2xl md:text-3xl tracking-widest transition-opacity duration-300 cursor-default select-none">
                AI & ML
              </span>
              <span className="text-white font-bold text-2xl md:text-3xl tracking-widest transition-opacity duration-300 cursor-default select-none">
                SAP
              </span>
              <span className="text-white font-bold text-2xl md:text-3xl tracking-widest transition-opacity duration-300 cursor-default select-none">
                INFOR
              </span>
              <span className="text-white font-bold text-2xl md:text-3xl tracking-widest transition-opacity duration-300 cursor-default select-none">
                Odoo
              </span>
              <span className="text-white font-bold text-2xl md:text-3xl tracking-widest transition-opacity duration-300 cursor-default select-none">
                Cloud
              </span>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .hero-bg-video {
            animation: heroZoom 4s ease-out forwards;
            transform: scale(1);
          }

          @keyframes heroZoom {
            from {
              transform: scale(1);
            }
            to {
              transform: scale(1.06);
            }
          }
        `}
      </style>
    </section>
  );
}
